import { useState } from 'react';
import Modal from 'react-modal';
import DOMPurify from 'dompurify';
// import { Carousel } from 'react-responsive-carousel';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useTranslation } from "react-i18next";

import { charactersList } from './content/charactersList';

const customStyles = {
  content: {
    top: '120px',
  },
};

export const Characters = () => {
  const { t } = useTranslation();

  const [active, setActive] = useState();
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = (character) => {
    setIsOpen(true);
    setActive(character);
  }

  const closeModal = () => {
    setIsOpen(false);
    setActive();
  }

  const responsive = {
    desktop: {
      breakpoint: { max: 40000, min: 900 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1200, min: 768 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };

  return (
    <div className="container-bg">
      <div className="container">
        <h3 className="container-title">{t("characters.title")}</h3>
      </div>
        <Carousel
          centerMode={true}
          swipeable={true}
          draggable={true}
          showDots={true}
          responsive={responsive}
          ssr={false} // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={1500}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={300}
          containerClass="characters-carousel"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {charactersList.map(character => 
            <div key={character.name} className="card card-character">
              <img src={`characters/${character.img}`} alt={character.name} />
              <p className="card-title text-center">{character.name}</p>
              {/* <p className="text-center card-character-link" onClick={() => openModal(character)}>
                Zobacz więcej
              </p> */}
            </div>
          )}
        </Carousel>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <button onClick={closeModal} className="btn-close">X</button>
        {active && (
          <>
            <img src={`characters/${active.img}`} alt={active.name} />
            <p className="card-title text-center">{active.name}</p>
            {active.label && <p className="card-date text-center">{active.label}</p>}
            {active.description.map(text =>
              <p className="card-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}/>
            )}
            <div className="text-center">
              <button className="button button-link" onClick={closeModal}>Close</button>
            </div>
          </>
        )}
      </Modal>
    </div>
  )
};

export default Characters